export default "__VITE_ASSET__$0jKgUxf__"